<template>
  <div class="hot-list">
    <ul class="list">
      <li
        v-for="item in hotContent"
        :key="item.id"
        @click="$router.push('/lesson-detail/' + item.id)"
      >
        <div class="img-content">
          <img :src="item.cover_img" alt="" />
          <div class="info">
            <div class="teacher-name" v-if="type==1">
              {{ item.course_teachers[0].nick_name }}
            </div>
            <div class="teacher-name" v-else>
              {{ item.teacher_list[0].nick_name }}
            </div>
            <div class="play-num">{{ item.play_num }}</div>
          </div>
        </div>
        <div class="title o1">{{ item.title }}</div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "hot-list",
  data() {
    return {
      hotContent: [],
      type: null
    };
  },
  created() {
    this.type = this.$route.query.type;
  },
  mounted() {
    if (this.type == 1) {
      this.gethot();
    } else {
      this.getnine();
    }
  },
  methods: {
    gethot() {
      this.$api.get(
        "",
        {
          api: "/v1/home_page/hot"
        },
        res => {
          if (res.status === 1) {
            this.hotContent = res.data.list;
            console.log(this.hotContent)
          }
        }
      );
    },
    getnine() {
      this.$api.get(
        "",
        {
          api: "/v1/home_page/recommend"
        },
        res => {
          if (res.status === 1) {
            this.hotContent = res.data.list;
          }
        }
      );
    }
  }
};
</script>
<style scoped>
.hot-list {
  padding: 0.4rem;
  box-sizing: border-box;
}
.hot-list * {
  box-sizing: border-box;
}
.hot-list ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.4rem;
}
.hot-list ul li {
  width: 4.4rem;
}
.hot-list ul .img-content {
  position: relative;
  width: 100%;
  height: 2.92rem;
  border-radius: 0.213rem;
  overflow: hidden;
}
.hot-list ul .img-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hot-list ul .img-content .info {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0.747rem;
  line-height: 0.747rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 0 0.213rem;
  display: flex;
  justify-content: space-between;
  color: #ffffff;
  font-size: 0.32rem;
}
.hot-list ul .title {
  width: 100%;
  padding: 0 0.213rem;
  margin-top: 0.24rem;
  line-height: 0.4rem;
  font-size: 0.4rem;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/hot-list/hot-list.vue